import { useParams } from "react-router-dom"
import { fromPairs, toPairs } from "ramda"

export function useParsedParams(types) {
  return fromPairs(
    toPairs(useParams()).map(([key, param]) => [key, types[key](param)]),
  )
}
